import CommonTable from "@/components/commonTable";
import { calibrateAqiInsRequest, calibrateDuolaimuRequest } from "@/service/calibrate";
import { useTable } from "@/utils/useTable";
import { useMemo } from "react";
import { renderAqiInsCalibrationStatus } from "./status";

interface CalibrateTableAqiInsProps {
    diagnosisSearchParams: any;
    carId?: number
}


const CalibrateTableAqiIns = (props: CalibrateTableAqiInsProps) => {
    const { diagnosisSearchParams = {}, carId } = props;

    const searchParams = useMemo(() => {
        const _params = {
            ...diagnosisSearchParams
        }
        if (carId) {
            _params.carId = carId;
        }
        return _params;
    }, [diagnosisSearchParams, carId]);

    const columns = [
        {
            title: '上报时间',
            dataIndex: 'reportTime'
        },
        {
            title: '参数版本号',
            dataIndex: 'version'
        },
        {
            title: '标定状态',
            dataIndex: 'success',
            render: renderAqiInsCalibrationStatus
        },
    
    ] ;
    const { page, limit, loading, data, totalCount, onPageChange } = useTable({
        requestFunc: calibrateAqiInsRequest,
        initRequest: true,
        initPageSize: 40,
        searchParams
    });

    return (
        <CommonTable
            rowKey="id"
            columns={columns}
            dataSource={data}
            pagination={{
                total: totalCount,
                current: page,
                pageSize: limit,
                onChange: onPageChange
            }}
            bordered
            loading={loading}
            scroll={{ x: '100%', y: 400 }}
        />
    );
};

export default CalibrateTableAqiIns;
